import React, { useEffect, useState } from "react";
import {
  Card,
  TextField,
  Typography,
  Grid,
  Box,
  useTheme,
  Button,
  CircularProgress,
} from "@mui/material";
import { tokens } from "../../../../theme";
import { customerservice, setupManagementUrl } from "../../../../config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import {
  generateAndExecuteCustomerApproval,
  generateAndExecuteMutation,
  generateAndExecuteMutationException,
} from "../../../../data/Axios/DynamicService";
import {
  fetchJson,
  fetchJsonDynamic,
} from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Joyride from "react-joyride";

const CustomerAwaitingApproval = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const CustomerId = localStorage.getItem("CustomerId");
  // const CustomerID = localStorage.getItem("CustomerId");
  const [data, setData] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [isLoadingReject, setIsLoadingReject] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [approvalComments, setApprovalComments] = useState("");
  const [employers, setEmployers] = useState([]);
  const [isSkipExtraDetailsEnabled, setIsSkipExtraDetailsEnabled] = useState(false);

  const base_url = customerservice.uri;

  const [runTour, setRunTour] = useState(true);

  const steps = [
    {
      target: ".back-button",
      content: "Click here to go back to the customer list.",
    },
    {
      target: ".data-area",
      content: "This area contains the customer's Details.",
    },
    {
      target: ".approve-button",
      content: "Approve the customer after reviewing their details.",
    },
    {
      target: ".reject-button",
      content: "Reject the customer and send them back to registration.",
    },
  ];

  const navigate = useNavigate();

  const handlesearch = async () => {
    setLoadingSearch(true); // Start loading
    try {
      const mutationdata = { id: parseInt(CustomerId) };

      // Perform API call to search customer
      const customer = await fetchJsonDynamic(
        "customersById",
        "customer",
        mutationdata,
        base_url,
      );

      const result = JSON.parse(customer?.results);

      if (result === null || result.length === 0) {
        setData([]);
        Swal.fire("Sorry!", "Customer to be approved not found", "warning");
      } else {
        setData(result[0] || null); // Update state with customer data
      }
    } catch (error) {
      console.error("Search error:", error);
      Swal.fire(
        "Search Failed",
        "An error occurred during the search. Please try again later.",
        "error",
      );
    } finally {
      setLoadingSearch(false); // End loading after search is completed
    }
  };
  useEffect(() => {
    async function fetchEmployers() {
      const response = await fetchJsonDynamic(
        "allEmployers",
        null,
        null,
        setupManagementUrl.uri,
      );
      const parsed = JSON.parse(response?.results || "[]");
      setEmployers(parsed);
    }

    fetchEmployers();
  }, []);
 useEffect(() => {
  async function fetchCustomerSettings() {
    try {
      const response = await fetchJsonDynamic(
        "customerSettings",
        null,
        null,
        customerservice.uri
      );

      // Handle the actual API response structure
      const settingsResult =
        response?.data?.customerSettings?.results ??
        response?.customerSettings?.results ??
        response?.results;

      const settings =
        typeof settingsResult === "string"
          ? JSON.parse(settingsResult)
          : settingsResult;

      if (Array.isArray(settings)) {
        const extraDetailsSetting = settings.find(
          (s) =>
            (s.Setting || "").trim() ===
            "Leave Out the Extra Customer Details e.g (NOK, Business Details and Guarantors)"
        );

        const isEnabled =
          String(extraDetailsSetting?.Value || "")
            .trim()
            .toLowerCase() === "true";

        setIsSkipExtraDetailsEnabled(isEnabled);

        console.log("Extra Customer Details Setting:", extraDetailsSetting);
        console.log("Skip Extra Details Enabled:", isEnabled);
      }
    } catch (error) {
      console.error("Error fetching customer settings:", error);
      setIsSkipExtraDetailsEnabled(false);
    }
  }

  fetchCustomerSettings();
}, []);

  useEffect(() => {
    handlesearch();
  }, [CustomerId]);

  const extractErrorMessage = (errorString) => {
    // Regex to extract the error message between "P0001:" and "at"
    const regex = /P0001:\s*([\s\S]*?)\s*at/;
    const match = errorString.match(regex);

    if (match && match[1]) {
      // Replace "\\n" and "\\r\\n" with commas
      const formattedMessage = match[1].replace(/\\n|\\r\\n/g, ", ");
      return formattedMessage.trim(); // Trim any leading/trailing spaces
    }

    return null; // Return null if no error message is found
  };

  const handleApprove = async (customerId) => {
    try {
      // Open a confirmation dialog with an input field for approval comments
      const { value: comment, isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "Please enter a comment for approval:",
        input: "text",
        inputPlaceholder: "Enter your comment here...",
        showCancelButton: true,
        confirmButtonText: "Approve",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value) {
            return "You need to enter a comment!";
          }
        },
      });

      // If the user confirms and provides a comment, proceed with the approval
      if (isConfirmed && comment) {
        setIsLoadingApprove(true); // Start loading
        const CustomerId = parseInt(customerId);
        const mutationData = {
          customerid: CustomerId,
          p_flag: true,
          p_approvalcomments: comment, // Use the comment from the dialog
        };

        // Make the API call to approve the customer
        const response = await generateAndExecuteCustomerApproval(
          "approveRejectCustomer",
          mutationData,
          "approveCustomer",
          base_url,
        );

        if (response.approveRejectCustomer.results !== null) {
          // Show success notification
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Customer has been approved successfully.",
            confirmButtonText: "OK",
          });
        } else {
          const error = extractErrorMessage(
            response.approveRejectCustomer.error,
          );
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: `${error}`,
            confirmButtonText: "OK",
          });
        }
      }
      navigate(-1);
    } catch (error) {
      console.error("Error approving customer:", error);

      // Show error notification
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to approve the customer. Please try again.",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoadingApprove(false); // Stop loading
    }
  };

  const handleReject = async (customerId) => {
    try {
      setIsLoadingReject(true); // Start loading
      const CustomerId = parseInt(customerId);
      const mutationData = {
        customerid: CustomerId,
        p_flag: false,
        p_approvalcomments: approvalComments,
      };
      // Make the API call to reject the customer
      const response = await generateAndExecuteCustomerApproval(
        "approveRejectCustomer",
        mutationData,
        "approveCustomer",
        base_url,
      );

      handlesearch();

      // Show success notification
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Customer sent Back to Registration Phase Successfully.",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error Declining customer:", error);

      // Show error notification
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to Decline the customer. Please try again.",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoadingReject(false); // Stop loading
    }
  };
  const getEmployerName = () => {
    if (!employers || !employers[0] || !employers.length) return " ";

    const employerId = data.EmployerId;
    const employer = employers.find((p) => p.Id === employerId);
    return employer ? employer.Employer : "";
  };

  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 3, md: 4 },
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <Joyride
        steps={steps}
        run={runTour}
        callback={(data) => {
          const { status, type } = data;
          const finishedStatuses = ["finished", "skipped"];

          if (finishedStatuses.includes(status)) {
            setRunTour(false); // Ensure it can be restarted later
          }
        }}
        showSkipButton
        showProgress
        continuous
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />

      {/* Search Bar */}
      <Grid container justifyContent="center">
        <Grid item>
          <>
            {loadingSearch ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Button
                className="back-button"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
              >
                Back To Customers
              </Button>
            )}
            <Button
              onClick={() => {
                setRunTour(false); // Reset first
                setTimeout(() => setRunTour(true), 100); // Restart tour
              }}
            >
              Start Tour
            </Button>
          </>
        </Grid>
      </Grid>

      {/* Customer Biodata */}
      {data.length !== 0 && (
        <Box sx={{ marginTop: 4 }} className="data-area">
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Customer Biodata
          </Typography>
          <Card elevation={3} sx={{ padding: { xs: 2, sm: 3 } }}>
            {/* Row 1 */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              {[
                { label: "CustomerID", value: data?.Id || "N/A" },
                { label: "First Name", value: data?.FirstName || "N/A" },
                { label: "Other Names", value: data?.OtherNames || "N/A" },
              ].map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box
                    sx={{
                      padding: 2,
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {item.label}
                    </Typography>
                    <Typography variant="body1" data-tour="customer-id">
                      {item.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Row 2 */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              {[
                {
                  label: "Date of Birth",
                  value:
                    dayjs(data?.DateOfBirth).format("MMM DD, YYYY") || "N/A",
                },
                {
                  label: "Mobile Number",
                  value: data?.MobileNumber || "N/A",
                },
                {
                  label: "Email Address",
                  value: data?.EmailAddress || "N/A",
                },
              ].map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box
                    sx={{
                      padding: 2,
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {item.label}
                    </Typography>
                    <Typography variant="body1">{item.value}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Row 3 */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              {[
                {
                  label: "ID No / Passport",
                  value: data?.IdNoOrPassport || "N/A",
                },
                {
                  label: "Postal Address",
                  value: data?.PostalAddress || "N/A",
                },
                {
                  label: "Physical Address",
                  value: data?.PhysicalAddress || "N/A",
                },
              ].map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box
                    sx={{
                      padding: 2,
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {item.label}
                    </Typography>
                    <Typography variant="body1">{item.value}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Row 4 */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              {[
                {
                  label: "Years Lived at Residence",
                  value: data?.YearsLivedAtResidence || 0,
                },
                { label: "Loan Limit", value: data?.LoanLimit },
                { label: "Postal Code", value: data?.PostalCode || "N/A" },
                {
                  label: "Average Cash Sales",
                  value: Number(data?.AverageCashSales || 0).toLocaleString(),
                },
                {
                  label: "Active",
                  value: data?.IsActive ? "Active" : "Inactive",
                  color: data?.IsActive ? "green" : "red",
                },
                {
                  label: "Approval Status",
                  value:
                    data?.IsApproved == 2
                      ? "Approved"
                      : data?.IsApproved == 1
                        ? "Pending Approval"
                        : data?.IsApproved == 0
                          ? "Process Not Started"
                          : "Declined",
                  color: data?.IsApproved == 2 ? "green" : "red",
                },
                ...(data?.EmployerId
                  ? [
                      {
                        label: "Employer",
                        value: getEmployerName(),
                      },
                    ]
                  : []),
              ].map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box
                    sx={{
                      padding: 2,
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      {item.label}
                    </Typography>
                    <Typography variant="body1" color={item.color || "inherit"}>
                      {item.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Buttons: Approve and Reject */}
            {(isSkipExtraDetailsEnabled ||
              data?.IsApproved === 2 ||
              data?.IsApproved === 1 ||
              data?.IsApproved === 0 ||
              data?.IsApproved === null) && (
              <>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap={2}
                  sx={{ mt: 3 }}
                >
                  {data?.IsApproved === 1 ||
                  data?.IsApproved === 0 ||
                  data?.IsApproved === null ? (
                    <>
                      <Button
                        className="approve-button"
                        variant="contained"
                        color="success"
                        onClick={() => handleApprove(data?.Id)}
                        disabled={isLoadingApprove}
                        startIcon={
                          isLoadingApprove && (
                            <CircularProgress size={20} color="inherit" />
                          )
                        }
                      >
                        {isLoadingApprove ? "Approving..." : "Approve"}
                      </Button>
                    </>
                  ) : (
                    <>
                      {/* <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleReject(data?.Id)}
                        disabled={isLoadingReject}
                        startIcon={
                          isLoadingReject && (
                            <CircularProgress size={20} color="inherit" />
                          )
                        }
                      >
                        {isLoadingReject ? "Declining..." : "Back to Registration Phase"}
                      </Button> */}
                      <Button
                        className="reject-button"
                        variant="contained"
                        color="error"
                        onClick={() => handleReject(data?.Id)}
                        disabled={isLoadingReject}
                        startIcon={
                          isLoadingReject && (
                            <CircularProgress size={20} color="inherit" />
                          )
                        }
                      >
                        {isLoadingReject
                          ? "Declining..."
                          : "Back to Registration Phase"}
                      </Button>
                    </>
                  )}
                </Box>
              </>
            )}
          </Card>
        </Box>
      )}
    </Box>
  );
};

export default CustomerAwaitingApproval;
